module.exports = __webpack_public_path__ + "res/img_collect_value.a94645937657ce649284a9e7ce2830f1.png";